<template>
  <v-dialog
    :value="value"
    width="500px"
  >
    <v-card min-height="400px">
      <v-card-title class="font-weight-bold" style="color: var(--v-secondary-base)">
        {{ $t('actions.selectDate') }}:
      </v-card-title>

      <v-card-text class="mt-1 pb-3 pt-2 subtitle-2 font-weight-bold">
        <v-layout justify-center>
          <v-date-picker
            v-model="dateRange"
            no-title
            range
            :max="new Date().toISOString()"
            :locale="getDatePickerLocale()"
            color="secondary"
          />
        </v-layout>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn outlined color="secondary" @click="cancelOperation()"> {{ $t('actions.cancel') }} </v-btn>
        <v-btn dark color="secondary" @click="confirmOperation()"> {{ $t('actions.confirm') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getDatePickerLocale from '@/mixins/getDatePickerLocale';

export default {
  name: 'DateRangeDialog',

  props: {
    value: Boolean,
  },

  data() {
    return {
      dateRange: [],
    };
  },

  mixins: [getDatePickerLocale],

  methods: {
    cancelOperation() {
      this.$emit('cancel-operation');
    },

    confirmOperation() {
      if (new Date(this.dateRange[0]) > new Date(this.dateRange[1])) {
        const temp = this.dateRange[1];
        this.dateRange[1] = this.dateRange[0];
        this.dateRange[0] = temp;
      }
      this.$emit('filter-approval-dates', this.dateRange);
    },

    getDateRange() {
      let dateOne = new Date().toISOString();
      dateOne = dateOne.substring(0, dateOne.indexOf('T'));

      let dateTwo = new Date();
      dateTwo.setDate(dateTwo.getDate() - 28);
      dateTwo = dateTwo.toISOString();
      dateTwo = dateTwo.substring(0, dateTwo.indexOf('T'));

      return [dateTwo, dateOne];
    },
  },

  created() {
    this.dateRange = this.getDateRange();
  },
};
</script>

<style scoped>
</style>
